"use client";

import { useState, useMemo } from "react";
import { FaChevronDown, FaChevronUp, FaSearch } from "react-icons/fa";
import { RiQuestionnaireLine } from "react-icons/ri";

const FAQClient = ({ data }) => { // Accept data as prop
  const [openQuestion, setOpenQuestion] = useState(null);
  const [openCategory, setOpenCategory] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");

  const handleToggle = (id) => {
    setOpenQuestion(openQuestion === id ? null : id);
  };

  const filteredFaqData = useMemo(() => {
    if (!searchTerm) return data;

    const lowerCaseSearchTerm = searchTerm.toLowerCase();

    return data
      .map((category) => {
        const filteredQuestions = category.questions.filter((item) => {
          const answerText = item.answer.replace(/<[^>]*>?/gm, "");
          return (
            item.question.toLowerCase().includes(lowerCaseSearchTerm) ||
            answerText.toLowerCase().includes(lowerCaseSearchTerm)
          );
        });

        return { ...category, questions: filteredQuestions };
      })
      .filter((category) => category.questions.length > 0);
  }, [searchTerm, data]);

  const handleSearchChange = (event) => {
    setOpenCategory(null);
    setOpenQuestion(null);
    setSearchTerm(event.target.value);
  };

  return (
    <section className="max-w-5xl mx-auto p-6 mt-16">
      <h2 className="text-3xl font-bold text-center mb-8 flex items-center justify-center gap-3 text-black">
        <RiQuestionnaireLine className="text-4xl text-black" />
        پرسش های متداول
      </h2>

      {/* Search Input */}
      <div className="relative mb-8">
        <input
          type="text"
          placeholder="جستجو در پرسش ها و پاسخ‌ها..."
          value={searchTerm}
          onChange={handleSearchChange}
          className="w-full py-3 pr-12 pl-4 border border-gray-300 rounded-xl focus:outline-none focus:ring-1 focus:ring-black focus:border-black text-lg text-right"
          dir="rtl"
        />
        <FaSearch className="absolute right-4 top-1/2 transform -translate-y-1/2 text-gray-400" />
      </div>

      {filteredFaqData.length === 0 && searchTerm && (
        <div className="text-center py-10 bg-gray-50 rounded-lg text-xl text-gray-600 border border-dashed">
          نتیجه‌ای برای جستجوی **"{searchTerm}"** یافت نشد.
        </div>
      )}

      {filteredFaqData.map((category, categoryIndex) => (
        <div key={categoryIndex} className="mb-6">
          <button
            onClick={() => !searchTerm && setOpenCategory(openCategory === categoryIndex ? null : categoryIndex)}
            className={`w-full flex justify-between items-center py-3 px-4 rounded-lg transition-colors ${
              searchTerm 
                ? "bg-gray-100 text-black cursor-default font-bold" 
                : "bg-gray-100 hover:bg-gray-200 text-black font-semibold"
            }`}
          >
            <span className="text-xl font-semibold">{category.category}</span>
            {!searchTerm && (
              <span className="text-2xl">{openCategory === categoryIndex ? "−" : "+"}</span>
            )}
          </button>

          {/* CRITICAL CHANGE FOR SEO (Optional but Recommended): 
             Instead of not rendering the div at all when closed, you can render it 
             hidden with CSS. However, the JSON-LD approach (Step 3) is more effective.
             For now, we keep your logic but rely on Step 3 for indexing.
          */}
          {(searchTerm || openCategory === categoryIndex) && (
            <div className="space-y-4 mt-4">
              {category.questions.map((item, questionIndex) => {
                const uniqueId = `${categoryIndex}-${questionIndex}`;
                return (
                  <div key={questionIndex} className="border-b border-gray-300">
                    <button
                      onClick={() => handleToggle(uniqueId)}
                      className="w-full text-right flex items-start py-4 px-6 text-lg font-medium text-gray-800 hover:bg-gray-100 transition-all"
                    >
                      <span className="flex-1 min-w-0 pr-4">{item.question}</span>
                      <span className="shrink-0 pt-1">
                        {openQuestion === uniqueId ? (
                          <FaChevronUp className="text-black" />
                        ) : (
                          <FaChevronDown className="text-black" />
                        )}
                      </span>
                    </button>
                    {openQuestion === uniqueId && (
                      <div className="p-4 sm:p-6 text-gray-800 bg-gray-50 border-r-4 border-black text-right">
                        <div dangerouslySetInnerHTML={{ __html: item.answer }} />
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          )}
        </div>
      ))}
    </section>
  );
};

export default FAQClient;